import type { BusyState } from "./welcome-onboarding-types";
import { resizeAvatar } from "./welcome-onboarding-utils";

interface BusySliceInput {
  action: () => Promise<void>;
  setBusy: (value: BusyState) => void;
  setMessage: (value: string | null) => void;
  state: BusyState;
}

interface AvatarInput {
  file: File | null;
  onAvatarUrl: (value: string) => void;
  setBusy: (value: BusyState) => void;
  setMessage: (value: string | null) => void;
}

const MAX_AVATAR_INPUT_BYTES = 8_000_000;

export async function runBusySlice(input: BusySliceInput) {
  input.setBusy(input.state);
  input.setMessage(null);
  try {
    await input.action();
  } catch (error) {
    input.setMessage(
      error instanceof Error ? error.message : "Onboarding failed.",
    );
  } finally {
    input.setBusy("idle");
  }
}

export async function chooseProfileAvatar(input: AvatarInput) {
  if (!input.file) return;
  if (input.file.size > MAX_AVATAR_INPUT_BYTES) {
    input.setMessage("Profile image must be under 8MB.");
    return;
  }
  input.setBusy("saving");
  try {
    input.onAvatarUrl(await resizeAvatar(input.file));
    input.setMessage("Profile image ready.");
  } catch {
    input.setMessage("Profile image could not be processed.");
  } finally {
    input.setBusy("idle");
  }
}
